import CardPartnerAccessTile from './CardPartnerAccessTile';

export default CardPartnerAccessTile;
